import { createdATFilter } from 'modules/common/constants';

export const disallowedWordFilters = [createdATFilter];
